var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIMinimize = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7 -308.287)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(7 308.287)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8 -1.459)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15 309.287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.693,5.029,8.7,7.251l2.234-.01",
    fill: "none",
    className: "stroke-gray",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.71,7.245l3.311-3.361",
    fill: "none",
    className: "stroke-gray",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.307,10.971,7.3,8.749l-2.234.01",
    fill: "none",
    className: "stroke-gray",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.29,8.755,3.979,12.116",
    fill: "none",
    className: "stroke-gray",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15 309.287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.541,12.906V3.094a1.635,1.635,0,0,0-1.635-1.635H3.094A1.635,1.635,0,0,0,1.459,3.094v9.812a1.635,1.635,0,0,0,1.635,1.635h9.812A1.635,1.635,0,0,0,14.541,12.906Z",
    fill: "none",
    className: "stroke-gray",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIMinimize, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/i_minimize.059e61b4.svg";
export { ForwardRef as ReactComponent };